












import {
  defineComponent
} from '@nuxtjs/composition-api'
import CmsBlocks from 'components/theme/Content/CmsBlocks.vue';
import { useConfig } from '@wemade-vsf/composables';

export default defineComponent({
  name: 'AppFooter',
  components: {
    CmsBlocks
  },
  setup () {
    const { config } = useConfig()

    const blockIdentifiers = config.value?.storefront?.footer_block_identifier || null

    const copyright = config.value.copyright ?? ''
    
    return {
      blockIdentifiers,
      copyright
    }
  }
})
